const styles = {
  card: {
    height: '70vh',
    overflowY: 'auto',
  },
};

export default styles;
